module.exports = axios;


//////////////////
// WEBPACK FOOTER
// external "axios"
// module id = 18
// module chunks = 0